/**
 * Reducer for managing color-related state
 * Consolidates color loading state to reduce complexity
 */

export const COLOR_ACTIONS = {
  SET_COLORS_LOADED: "SET_COLORS_LOADED",
  SET_LOADED_ACCOUNT_IDS: "SET_LOADED_ACCOUNT_IDS",
};

export const colorReducer = (state, action) => {
  switch (action.type) {
    case COLOR_ACTIONS.SET_COLORS_LOADED:
      return {
        ...state,
        colorsLoaded: typeof action.payload === "function"
          ? action.payload(state.colorsLoaded)
          : action.payload,
      };

    case COLOR_ACTIONS.SET_LOADED_ACCOUNT_IDS:
      return {
        ...state,
        loadedAccountIds: action.payload,
      };

    default:
      return state;
  }
};

export const createColorActions = (dispatch) => {
  // Use stable function references to prevent unnecessary re-renders
  const setColorsLoaded = (countOrFn) =>
    dispatch({
      type: COLOR_ACTIONS.SET_COLORS_LOADED,
      payload: countOrFn,
    });
  const setLoadedAccountIds = (ids) =>
    dispatch({
      type: COLOR_ACTIONS.SET_LOADED_ACCOUNT_IDS,
      payload: ids instanceof Set ? ids : new Set(ids),
    });

  return {
    setColorsLoaded,
    setLoadedAccountIds,
  };
};

